
import { createApp } from 'vue';
import App from './App.vue';
const app = createApp(App);


// Router
import router from './router';
app.use(router);

// Element Plus
import ElementPlus from './plugins/element-plus'; 
app.use(ElementPlus);

// adDictionary
import adDictionary from './adScripts/adDictionary'
app.mixin(adDictionary);


import store from './store'
app.use(store)

import './assets/scss/responsive.scss'

function getNavigationBarHeight() {
    const windowInnerHeight = window.innerHeight;
    const documentClientHeight = document.documentElement.clientHeight;
  
    // Calcular la altura de la barra de navegación
    const navigationBarHeight = windowInnerHeight - documentClientHeight;
  
    return navigationBarHeight;
  }
  
  // Obtener el tamaño de la barra de navegación
  var navigationBarHeight = getNavigationBarHeight();
  
  // Establecer el valor de la variable CSS --navbar-height
  document.documentElement.style.setProperty('--navbar-height', navigationBarHeight + 'px');
  
  
app.mount('#app');



